import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Input, Component} from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'lib-alarm-monocolor-svg',
  templateUrl: './alarm-monocolor-svg.component.html',
})
export class AlarmMonocolorSvgComponent {
  @Input() filled:  boolean;

}
